export const supportEmail = "hello@airmessage.org";
export const discordAddress = "https://discord.gg/prjdNWTzfA";
export const redditAddress = "https://reddit.com/r/AirMessage";
